<template>
  <div>

    <!-- Popup de chargement -->
    <v-dialog
      v-model="loadingDialog"
      persistent
      width="300"
    >
      <v-card color="primary" dark>
        <v-card-text>
          Chargement en cours...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Popup de succès -->
    <v-dialog v-model="successDialog" max-width="600">
      <v-alert type="success" class="mb-0">
        Suppression de la carte effectuée
      </v-alert>
    </v-dialog>

    <!-- Bouton de suppression de la carte -->
    <v-card class="pa-8 pa-sm-4" flat outlined>
      <v-card-title class="pa-0 mb-6" style="word-break: keep-all">Cliquez ici pour utiliser une autre carte</v-card-title>
      <v-sheet flat class="overflow-hidden d-flex flex-column" v-if="!loading">
        <v-btn color="primary" dark @click="supprimerCarteClicked">Changer ma carte de paiement</v-btn>
      </v-sheet>
    </v-card>

  </div>
</template>

<script>
import { PublicApi } from "@/plugins/api"

export default {
  components: {  },
  data() {
    return {
      loading: false, // Permet de cacher le bouton pour ne pas le spammer une fois cliqué.
      successDialog: false, // Toggle l'affiche de la popup de succès.
      loadingDialog: false, // Toggle l'affiche de la popup de chargement.
    }
  },
  props: {
    enabled: Boolean,
    idFacture: String,
  },
  watch: {
    // Lors de l'activation / désactivation du composant (par v-if) on réinitialise les variables d'état.
    enabled(value){
      this.loading = false;
      this.successDialog = false;
      this.loadingDialog = false;
    }
  },
  methods: {
    // Appel interne pour supprimer la carte actuelle des paiements récurrents.
    getDeleteCard: (factureId) => PublicApi.get("moneris-checkout/" + factureId + "/delete-card"),

    // Supprime la carte et notifie le composant parent de se rafraichir.
    supprimerCarteClicked() {
      this.loading = true;
      this.loadingDialog = true;

      this.getDeleteCard(this.idFacture)
        .then(async (response) => {
          this.loadingDialog = false;
          this.successDialog = true;
          this.cardDeleted();
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$router.push({
              name: "NotFound",
              message: error.response.status
            })
          } else {
            this.$router.push({
              name: "InternalError",
              message: error.response.message
            })
          }        
        })
    },

    // Notifie le composant parent de se rafraichir.
    cardDeleted() {
      this.$emit("cardDeleted")
    }
  }
}
</script>

<style scoped>
.solde {
  font-size: 1.5em;
}

.solde--montant {
  font-weight: bold;
}
</style>